import iconValues from './icons.json';

export type IconValueType = keyof typeof iconValues;

export const getIcon = (icon: IconValueType): string =>
  `\\${Number(iconValues[icon]).toString(16)}`;
